import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../shared/services/api/api.service';
import { Subscription } from 'rxjs';
import { EntityService } from '../../shared/services/entity.service';

@Component({
  selector: 'app-search-page',
  templateUrl: './search-page.component.html',
  styleUrl: './search-page.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SearchPageComponent implements OnDestroy {
  territoryUid = 'FRDEPA00';
  entityId: string | null = null;
  subscriptions: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private entityService: EntityService
  ) {
    this.route.params.subscribe(parameters => {
      this.territoryUid = parameters['territoryUid'];
      if (this.territoryUid !== 'FRDEPA00') {
        this.apiService.territory.retrieveTerritoryCounters(this.territoryUid).subscribe();
      }
    });

    this.subscriptions.push(
      this.entityService.getEntityId().subscribe(entityId => {
        this.entityId = entityId;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
